import clsx from 'clsx';

import { Typography } from '../typography/Typography';

type HelpTextProps = {
  title: string;
  description?: React.ReactElement | string;
  cta?: React.ReactElement;
  textLink?: React.ReactElement;
  type?: 'positive' | 'negative';
};

export const HelpText = ({
  title,
  description,
  cta,
  textLink,
  type,
}: HelpTextProps) => {

  const classes = clsx('space-y-4 p-4 md:p-6',
    {
      'bg-helptext-positive': type !== 'negative',
      'bg-helptext-negative': type === 'negative',
    });

  const titleColor = type !== 'negative' ? 'text-helptext-positive-title' : 'text-helptext-negative-title';
  const textColor = type !== 'negative' ? 'text-helptext-positive-text' : 'text-helptext-negative-text';
  const descriptionClasses = clsx(
    '[&_ul]:my-0 [&_ul>li+li]:mt-5 [&_li]:my-0 [&_li>p]:my-0 [&_p:empty]:hidden',
  );

  return (
    <div className={clsx(classes)}>
      {title ? (
        <Typography
          variant="title-body"
          textColorClassname={titleColor}
          type="h2"
        >
          {title}
        </Typography>
      ) : null}

      {description && (
        <Typography
          variant="content-body"
          textColorClassname={textColor}
          type="div"
          className={descriptionClasses}
        >
          {description}
        </Typography>
      )}

      {cta}

      {textLink}
    </div>

  );
};
